import { render, staticRenderFns } from "./MainSettingsEdit.vue?vue&type=template&id=17f682a8&scoped=true"
import script from "./MainSettingsEdit.vue?vue&type=script&lang=js"
export * from "./MainSettingsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f682a8",
  null
  
)

export default component.exports